var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLpCabinetPowerFunds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.89474C13.4183 8.89474 17 7.12744 17 4.94737C17 2.7673 13.4183 1 9 1C4.58172 1 1 2.7673 1 4.94737C1 7.12744 4.58172 8.89474 9 8.89474Z",
    stroke: "#FFD600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.94739V10.4737C1 12.6534 4.5816 14.4211 9 14.4211C13.4184 14.4211 17 12.6534 17 10.4737V4.94739",
    stroke: "#FFD600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.4736V15.9999C1 18.1797 4.5816 19.9473 9 19.9473C13.4184 19.9473 17 18.1797 17 15.9999V10.4736",
    stroke: "#FFD600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 16V21.5263C1 23.7061 4.5816 25.4737 9 25.4737C13.4184 25.4737 17 23.7061 17 21.5263V16",
    stroke: "#FFD600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 21.5264V27.0527C1 29.2324 4.5816 31.0001 9 31.0001C13.4184 31.0001 17 29.2324 17 27.0527V21.5264",
    stroke: "#FFD600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25 19.9473C29.4183 19.9473 33 18.1801 33 16C33 13.8199 29.4183 12.0526 25 12.0526C20.5817 12.0526 17 13.8199 17 16C17 18.1801 20.5817 19.9473 25 19.9473Z",
    stroke: "#FFD600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16V21.5263C17 23.7061 20.5816 25.4737 25 25.4737C29.4184 25.4737 33 23.7061 33 21.5263V16",
    stroke: "#FFD600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21.5264V27.0527C17 29.2324 20.5816 31.0001 25 31.0001C29.4184 31.0001 33 29.2324 33 27.0527V21.5264",
    stroke: "#FFD600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpCabinetPowerFunds);
export default __webpack_public_path__ + "static/media/lp_cabinet_power_funds.2e2e424dd1d6490ae4ca21295be286d1.svg";
export { ForwardRef as ReactComponent };